import { sendErrorToSentry } from '@/helpers/utils';
import store, { StorePayload } from '@/store';
import { StoreMutations } from '@/helpers/enums';

export class StoreMissingData extends Error {
  constructor(payload: StorePayload) {
    super('Store error');

    store.commit(
      StoreMutations.setAppError,
      'There was an error, please contact the support.'
    );

    sendErrorToSentry('Store error', {
      message: payload.action,
      payload: payload,
    });
  }
}
